if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        const useBgcLinkedAdd =
          window.BGCOptionAddons &&
          typeof window.BGCOptionAddons.isActive === 'function' &&
          window.BGCOptionAddons.isActive();

        const afterAdd = (response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        };

        const finish = () => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        };

        // Native Length/Grip linked lines (custom.option_pricing) — scoped; Hulk/BSS/PageFly untouched
        if (useBgcLinkedAdd) {
          Promise.resolve(window.BGCOptionAddons.buildCartItems(this.form))
            .then((items) => {
              if (!items || !items.length) {
                finish();
                return;
              }

              const sections = this.cart
                ? this.cart.getSectionsToRender().map((section) => section.id)
                : [];
              if (this.cart) this.cart.setActiveElement(document.activeElement);

              // Add sequentially so drawer sections come from the final Dawn-style /cart/add
              const addOne = (item, withSections) => {
                const fd = new FormData();
                fd.append('id', String(item.id));
                fd.append('quantity', String(item.quantity || 1));
                Object.entries(item.properties || {}).forEach(([key, value]) => {
                  fd.append(`properties[${key}]`, value);
                });
                if (withSections && sections.length) {
                  fd.append('sections', sections);
                  fd.append('sections_url', window.location.pathname);
                }
                return fetch(`${routes.cart_add_url}`, {
                  method: 'POST',
                  headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    Accept: 'application/javascript',
                  },
                  body: fd,
                }).then((response) => response.json());
              };

              const [main, ...addons] = items;
              let chain = addOne(main, addons.length === 0);

              addons.forEach((addon, index) => {
                chain = chain.then((prev) => {
                  if (prev && prev.status) return prev;
                  return addOne(addon, index === addons.length - 1);
                });
              });

              return chain.then((response) => {
                if (this.cart) this.cart.classList.remove('is-empty');
                afterAdd(response);
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(finish);
          return;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(afterAdd)
          .catch((e) => {
            console.error(e);
          })
          .finally(finish);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
